import {observer} from 'mobx-react';
import React from 'react';
import { render } from 'react-dom';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {SyncedAudioModel} from '../../models';
import {AudioElementStore} from '../common/AudioElementStore';
import {AudioProgress} from '../common/AudioProgress';
import {TeacherSyncedAudioStore} from './TeacherSyncedAudioStore';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore
}

function* trackedStudentProgress(store: TeacherSyncedAudioStore): ReactNodeGenerator {
  yield <AudioProgress className="student-progress" store={store.progress}
                       updateAudio={store.audio}/>
  // for (let [clientId, progressStore] of store.trackedStudents.entries())
  //   yield <AudioProgress key={clientId}
  //                        store={progressStore}
  //                        className="student-progress"
  //                        updateAudio={store.audio}/>;
}

@observer
class TeacherPlayButton extends React.Component<{ store: AudioElementStore }> {
  render() {
    const store = this.props.store;
    const classname = store.paused || store.ended
      ? 'fa fa-play'
      : 'fa fa-pause';
    return (
      <button type="button" className="btn btn-outline-primary"
              onClick={store.togglePlay}>
        <span className={classname}/>
      </button>);
  }
}

@observer
class TeacherSyncedAudioControls extends React.Component<{ store: TeacherSyncedAudioStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="row no-gutters">
        <div className="col-auto playerBlockButton">
          <TeacherPlayButton store={store.audio}/>
        </div>
        <div className="col playerBlock">
          <AudioProgress className="teacher-progress" store={store.progress}
                         updateAudio={store.audio}/>
          {
            Array.from(trackedStudentProgress(store))
          }
        </div>
      </div>
    );
  }
}

@observer
export class TeacherSyncedAudio extends React.Component<Props> {
  readonly audioRef = React.createRef<HTMLAudioElement>();

  readonly store: TeacherSyncedAudioStore;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(props.x9.Contents) as SyncedAudioModel;
    this.store = new TeacherSyncedAudioStore(props.x9.Id, model, props.store);
  }

  render() {
    const store = this.store;

    const handleError = () => {
      store.audio.setAudioError(true);
    }

    return (
      <div className="teacher-synced-audio">
        <audio ref={this.audioRef}
               src={store.model.audioUrl}
               controls={false}
               autoPlay={false}
               loop={false}
               preload="auto"
               onError={handleError}/>
        { store.audio.isAudioError && <p className="getUrlSourceError">Audio not found</p> }
        <TeacherSyncedAudioControls store={store}/>
      </div>);
  }

  componentDidMount() {
    this.store.audio.setElement(this.audioRef.current!);
  }

  componentWillUnmount() {
    this.store.audio.pause();
    this.store.audio.setCurrentTime(0);
    this.store.audio.setAudioError(false);
    this.store.dispose();
  }
}
